import React from "react";
import Card from "../components/shared/Card";

export default function AboutPage() {
  return (
    <Card>
      <div className="about-link">
        <h1>About this project</h1>
        <p>This a react app t0 leave feedback for a product or service</p>
      </div>
    </Card>
  );
}
